import { createReducer, on } from '@ngrx/store';
import attachmentsActions from './attachments.actions';
import { ApiState } from '../../model/api-state.model';
import { AttachmentsResponse } from '../../model/attachments.model';
import AppError from '../../model/app-error';

export { attachmentsActions as actions };

export * from './attachments.selectors';

export interface State {
  state: ApiState;
  data: AttachmentsResponse | null;
  error: AppError | null;
  downloadedFiles: string[];
}

export const initialState: State = {
  state: ApiState.idle,
  data: null,
  error: null,
  downloadedFiles: [],
};

export const reducer = createReducer(
  initialState,
  on(attachmentsActions.reset, () => initialState),
  on(attachmentsActions.fetchStart, (state) => ({ ...state, state: ApiState.pending, data: null, error: null })),
  on(attachmentsActions.fetchSuccess, (state, { data }) => ({ ...state, state: ApiState.success, data, error: null })),
  on(attachmentsActions.fetchError, (state, { error }) => ({ ...state, state: ApiState.error, data: null, error })),
  on(attachmentsActions.addDownloadedFile, (state, { url }) => ({
    ...state,
    downloadedFiles: [...new Set([...state.downloadedFiles, url])],
  })),
);
